export default __webpack_public_path__ + "static/media/flight.3795277c.jpg";